import "../MembershipCard/membershipCard.css";

export default function CurrentMembershipCard({data}) {
  return (
    <div className={`membershipCard currentMembership radius20 mb-md-0`}>
      <div className="membershipCard__Header d-flex justify-content-between">
        <div className="form-check">
          <label className="form-check-label m-0">{data.Plan_Name}</label>
        </div>
        <div className="current-plan-badge">
          Current Plan
        </div>
      </div>
      <div className="membershipCard__Body">
        <div className="d-flex justify-content-between">
          <div>Renewal Fees</div>
          <span>{data.Annual_Fees} + GST</span>
        </div>
        <div className="d-flex justify-content-between">
          <div>Billing Cycle</div>
          <span>Annual</span>
        </div>
      </div>
    </div>
  );
}
